import * as React from 'react';
import CourtReporting939DataCore from '../CourtReporting/CourtReporting939DataCore';
import { UserRoleEnum } from '../../redux/UserSlice';



const CourtReporting939LL = (props: any) => {
    return (
        <React.Fragment>
            <CourtReporting939DataCore userRole={UserRoleEnum.EntityUser} dataSection={"LawLibrary"} />
        </React.Fragment>
    );
}

export default CourtReporting939LL;